import React from 'react';
import { Typography, Box, Button, Chip } from '@mui/material';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { Message } from '../types/message';
import { User } from '../types/user';
import { APIHOST } from '../common';
import { useApp } from './AppContext';
import { useAuth } from './auth/AuthContext';

interface MessageStatusProps {
  message: Message;
  user: User;
  onUpdate?: () => void;
}
const formatDateTime = (dateString: string) => {
    return new Date(dateString).toLocaleString();
};

const MessageStatus: React.FC<MessageStatusProps> = ({ message, user, onUpdate }) => {
  const { userToken } = useAuth();
  const { setSnackbarInput } = useApp();
  const markAsRead = async () => {
   
    
    try {
      const response = await fetch(`${APIHOST}/api/messages/${message.documentId}/mark-as-read`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to mark message as read');
      }
      setSnackbarInput({ message: 'Message marked as read', severity: 'success' });
      if (onUpdate) {
        onUpdate();
      }
    } catch (error) {
      console.error('Error marking message as read:', error);
      setSnackbarInput({ message: 'Failed to mark message as read', severity: 'error' });
    }
  }

  // If this is the user's own message, just show the timestamp
  if (message.author.documentId === user.documentId && user.userType === 'user') {
    return (
      <Typography variant="caption" color="text.secondary">
        {formatDateTime(message.createdAt)}
      </Typography>
    );
   }

  // Otherwise, show read/unread status based on seenAt
  const isUnread = !message.seenAt;
  if (isUnread && message.author.documentId === user.documentId) {
    // If it's the user's own message and it's unread, just show the timestamp
    return (
      <Typography variant="caption" color="text.secondary">
        {formatDateTime(message.createdAt)} <Chip label="Unread" size="small" color="error" sx={{ ml: 0.5 }} />
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, flexDirection: 'column' }}>
      {isUnread ? <Box sx={{display: "flex", direction: "row", alignItems: "center", gap: 1}}>
        <Chip label={"Unread"} color={"warning"} size="small" sx={{ ml: 0.5 }} />
        <Button variant="outlined" size="small" startIcon={<MarkEmailUnreadIcon fontSize="small"/>} onClick={markAsRead}>
           Mark as Read
        </Button>
      </Box> : (
        <Typography variant="caption" color="text.secondary">
         <MarkEmailReadIcon fontSize="small" color="success" sx={{ mr: 0.5 }} />
          Read by {message.seenBy?.firstName} {message.seenBy?.lastName} at {formatDateTime(message.seenAt!)}
        </Typography>
      )}
        <Typography variant="caption" color="text.secondary">
            {formatDateTime(message.createdAt)}
        </Typography>
    </Box>
  );
};

export default MessageStatus;